import z from "zod";
import { AssetIdSchema, AssetSchema, ProjectIdSchema } from "@storytell/types";

export const AssetIdParamsSchema = z.object({
  id: AssetIdSchema,
});

export const CreateAssetInputSchema = AssetSchema.pick({
  displayName: true,
  description: true,
  fileName: true,
  contentType: true,
  labels: true,
});
export type CreateAssetInput = z.infer<typeof CreateAssetInputSchema>;

export const UpdateAssetInputSchema = AssetSchema.pick({
  displayName: true,
  description: true,
  labels: true,
});
export type UpdateAssetInput = z.infer<typeof UpdateAssetInputSchema>;

// Sync endpoint returns a map of asset IDs to asset objects
export const AssetsSyncSchema = z.object({
  assets: z.record(AssetIdSchema, AssetSchema),
});
export type AssetsSync = z.infer<typeof AssetsSyncSchema>;

// HTTP API schemas for file upload flow
export const CreateAssetHttpInputSchema = z.object({
  name: z.string(),
  filename: z.string(),
  fileSizeInBytes: z.number(),
  mimeType: z.string(),
  md5: z.string(),
  projectId: z.string().optional(),
  description: z.string().optional(),
});
export type CreateAssetHttpInput = z.infer<typeof CreateAssetHttpInputSchema>;

export const CreateAssetHttpResponseSchema = AssetSchema.extend({
  method: z.enum(["SIGNED_URL", "DIRECT"]),
  signedUrl: z.string().optional(),
});
export type CreateAssetHttpResponse = z.infer<typeof CreateAssetHttpResponseSchema>;

export const UploadCompleteParamsSchema = z.object({
  assetId: AssetIdSchema,
});
export type UploadCompleteParams = z.infer<typeof UploadCompleteParamsSchema>;

export const GetAssetsRequestSchema = z.object({
  assetIds: z.array(AssetIdSchema),
});
export type GetAssetsRequest = z.infer<typeof GetAssetsRequestSchema>;

export const GetAssetsResponseSchema = z.array(AssetSchema);
export type GetAssetsResponse = z.infer<typeof GetAssetsResponseSchema>;

export const MoveDestinationSchema = z.object({
  assetId: AssetIdSchema,
  projectId: ProjectIdSchema,
});
export type MoveDestination = z.infer<typeof MoveDestinationSchema>;

export const MoveAssetsRequestSchema = z.object({
  assets: z.array(MoveDestinationSchema),
});
export type MoveAssetsRequest = z.infer<typeof MoveAssetsRequestSchema>;
